export type ErrorType =
  | "offline"
  | "server-error"
  | "database-error"
  | "timeout"
  | "auth-required"
  | "forbidden"
  | "not-found"
  | "config-error"
  | "unknown";

export interface ErrorDetails {
  type: ErrorType;
  title: string;
  message: string;
}

export interface ErrorScreenProps {
  errorType?: ErrorType;
  title?: string;
  message?: string;
  onRetry?: () => void;
  retrying?: boolean;
}

export class CategorizedError extends Error {
  public readonly type: ErrorType;
  public readonly statusCode?: number;

  constructor(message: string, type: ErrorType, statusCode?: number) {
    super(message);
    this.name = "CategorizedError";
    this.type = type;
    this.statusCode = statusCode;
  }
}
